import { updateFieldsWithErrors } from '../../../helpers/utils/form.utils';
import { haveExceptionValidations, isBadRequestException } from '../../../helpers/utils/utils';
import { enviarClienteEmailProcessoService } from '../../../services/core/processos/processosService';

class AcaoEnviarConsultaClienteController {
  makeFormFields(values) {
    return {
      emailCliente: values?.emailCliente || '',
      nomePreposto: values?.nomePreposto || '',
      emailUsuario: values?.emailUsuario || '',
      texto: values?.texto || '',
      anexos: values?.anexos || [],
    };
  }

  makeErrorFields() {
    return {
      emailCliente: {
        error: false,
        errorMessage: '',
      },
      nomePreposto: {
        error: false,
        errorMessage: '',
      },
      emailUsuario: {
        error: false,
        errorMessage: '',
      },
      texto: {
        error: false,
        errorMessage: '',
      },
    };
  }

  makePayload(idProcesso, formTarget, texto, fases) {
    return {
      idProcesso,
      emailCliente: formTarget?.emailCliente.value,
      emailUsuario: formTarget?.emailUsuario.value,
      nomePreposto: formTarget?.nomePreposto.value,
      texto,
      fases,
    };
  }

  async enviarEmailCliente(idProcesso, formTarget, errorFields, textoValue, fasesPermitidasUsuario, anexos) {
    const fases = fasesPermitidasUsuario.join(',');
    const data = new FormData();
    try {
      anexos.forEach((anexo) => {
        data.append('anexos', anexo);
      });
      data.append('idProcesso', idProcesso);
      data.append('emailCliente', formTarget?.emailCliente.value);
      data.append('emailUsuario', formTarget?.emailUsuario.value);
      data.append('nomePreposto', formTarget?.nomePreposto.value);
      data.append('texto', textoValue);

      await enviarClienteEmailProcessoService(data, fases);

      return { success: true, errorFields };
    } catch (exception) {
      if (isBadRequestException(exception) && haveExceptionValidations(exception)) {
        const [updateErrorFields] = updateFieldsWithErrors(exception, errorFields);
        return { success: false, errorFields: updateErrorFields };
      }
      return { success: false, errorFields };
    }
  }
}

export const acaoEnviarConsultaClienteController = new AcaoEnviarConsultaClienteController();
